import { render } from "./carUserinfoCollect.vue?vue&type=template&id=33c43da3"
const script = {}

import "./carUserinfoCollect.vue?vue&type=style&index=0&id=33c43da3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__